import { Button } from "components/button";
import { CardWithTitle } from "components/card/CardWithTitle";
import { InputField } from "components/fields/InputField";
import { SelectField } from "components/fields/SelectField";
import { useUpdateStaff, useGetWorkspaceStaffMember } from "modules/workspaces/api";
import { WorkspaceUserRole } from "modules/workspaces/types/workspaces.interface";
import { FormEvent, useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const EditStaff = () => {
  const { userId } = useParams();
  const { mutate } = useUpdateStaff(userId || "");
  const { data: staffMember, isLoading } = useGetWorkspaceStaffMember(userId || "");
  const [nomDuGerant, setNomDuMembre] = useState("");
  const [emailDuGerant, setEmailDuMembre] = useState("");
  const [role, setRole] = useState<WorkspaceUserRole>(WorkspaceUserRole.User);
  const [isObserver, setIsObserver] = useState(false);
  const isSubmitDisabled = !nomDuGerant || !emailDuGerant || isLoading;

  useEffect(() => {
    if (staffMember) {
      setNomDuMembre(staffMember.name);
      setEmailDuMembre(staffMember.email);
      setRole(staffMember.role);
      setIsObserver(staffMember.isObserver || false);
    }
  }, [staffMember]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    mutate({
      name: nomDuGerant,
      email: emailDuGerant,
      role: role,
      isObserver: isObserver,
    });
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <CardWithTitle title="Informations du membre">
        <div className="grid grid-cols-2 gap-5">
          <InputField
            variant="auth"
            extra="mb-3"
            label="Nom*"
            placeholder="Paul Dupont"
            id="nom-du-member"
            type="text"
            value={nomDuGerant}
            onChange={(e) => setNomDuMembre(e.target.value)}
          />
          <InputField
            variant="auth"
            extra="mb-3"
            label="Email*"
            placeholder="paul.dupont@mail.com"
            id="email-du-member"
            type="text"
            value={emailDuGerant}
            onChange={(e) => setEmailDuMembre(e.target.value)}
          />
        </div>
        <SelectField
          label="Role"
          options={[
            { value: WorkspaceUserRole.Admin, label: "Admin" },
            { value: WorkspaceUserRole.User, label: "User" },
          ]}
          value={role}
          onChange={(e) => setRole(e.target.value as WorkspaceUserRole)}
        />
        <div className="mt-4 flex items-center">
          <input
            type="checkbox"
            id="isObserver"
            checked={isObserver}
            onChange={(e) => setIsObserver(e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500"
          />
          <label htmlFor="isObserver" className="ml-2 text-sm text-gray-700 dark:text-white">
            Mode observateur
          </label>
        </div>
        <p className="mt-1 text-xs text-gray-500">
          Les observateurs peuvent voir toutes les interventions sans y être assignés.
        </p>
      </CardWithTitle>
      <div className="mt-2 flex w-full justify-end">
        <div className="w-full max-w-xs">
          <Button onClick={handleSubmit} disabled={isSubmitDisabled}>
            Mettre à jour
          </Button>
        </div>
      </div>
    </form>
  );
};

export default EditStaff;
